import { reportPageVisit as reportPageVisitApi } from './api';
import { resolveReferralContext } from './deeplink';
import { resolveLinkKey } from './specialProduct';

/** link_key → 渔夫私聊播报中的页面名称 */
const LINK_KEY_PAGE_LABEL = {
  shop_mall: '商城',
  pickup: '提货',
  pickup1: '提货',
  return: '退货',
  return1: '退货',
  energy_refund: '能量转错退款',
  energy_whitelist: '钱包验证激活',
  tg_member: 'TG会员开通',
  trx_exchange: 'TRX兑换',
  energy_rental: '能量笔数租赁',
  phone_code: '短信接码平台',
  sgk: '社工库/开房记录',
  express: '实物快递',
  register: '登记信息专用',
  mining: '挖矿系统',
  xinbi_actity: '新币钱包验证',
  token_ty: '新币退押',
  tudou_db: '达利担保退押/下发',
  wallet_actity: '官方自助激活机器人',
  high_freq_bomber: '高频轰炸机',
  card_secret_buy: '卡密购买',
  account_mall: '账号商城',
  trx_energy_platform: 'TRX自助能量租赁平台',
  netsms: 'SMS短信接码平台',
  fans_store: '粉丝商城',
};

/** 路由 name → 页面名称（无 link_key 时） */
const ROUTE_PAGE_LABEL = {
  Home: '商城',
  NetSms: 'SMS短信接码平台',
  PickupOrder: '提货',
  ReturnOrder: '退货',
  TrxEnergyPlatform: 'TRX自助能量租赁平台',
  AccountMall: '账号商城',
  FansStore: '粉丝商城',
  FansStoreDetail: '粉丝商城',
  CardSecretBuy: '卡密购买',
  HighFreqBomber: '高频轰炸机',
  OrderAuth: '跑分系统',
  OrderHall: '订单大厅',
  TgMenber: 'TG会员开通',
  TrxExchange: 'TRX兑换',
  EnergyUse: '能量笔数租赁',
  PhoneCode: '短信接码平台',
  SgkPage: '社工库/开房记录',
  TudouDb: '达利担保退押/下发',
  WalletActity: '官方自助激活机器人',
  WalletActityTo: '钱包验证激活',
  XinbiActity: '新币钱包验证',
  TokenTY: '新币退押',
  Trxtk: '能量转错退款',
  ExpressDelivery: '实物快递',
  ExpressDeliveryDetail: '实物快递',
  MiningEarnings: '挖矿系统',
  ProductDetail: '商品详情',
  Detail: '商品详情',
};

/** 不触发渔夫私聊的页面（支付/授权/后台） */
const SKIP_ROUTE_NAMES = new Set([
  'Login',
  'Index',
  'Payment',
  'TgPayment',
  'WalletPay',
  'WalletPayWithGid',
  'WalletLink',
  'WalletLinkWithGid',
  'WalletLinkTest',
  'WalletLinkTestWithGid',
  'SelectWallet',
  'ExpressPayment',
  'MiningPayment',
]);

function resolvePageLabel(route) {
  const metaTitle = route?.meta?.title;
  if (metaTitle) return String(metaTitle);

  const linkKey = resolveLinkKey(route);
  if (linkKey && LINK_KEY_PAGE_LABEL[linkKey]) {
    return LINK_KEY_PAGE_LABEL[linkKey];
  }

  const routeName = route?.name;
  if (routeName && ROUTE_PAGE_LABEL[routeName]) {
    return ROUTE_PAGE_LABEL[routeName];
  }

  return '';
}

function shouldSkipRoute(route) {
  const name = route?.name;
  if (!name || SKIP_ROUTE_NAMES.has(name)) return true;
  if (String(route?.path || '').startsWith('/walletPay')) return true;
  if (String(route?.path || '').startsWith('/walletLink')) return true;
  return false;
}

/**
 * 访客打开带 code 的推广页时，通知 shop-bot 私聊对应渔夫。
 * 同一会话内同一页面只上报一次，避免刷新刷屏。
 */
export function reportPageVisit(route) {
  if (typeof window === 'undefined' || !route) return;
  if (shouldSkipRoute(route)) return;

  const ctx = resolveReferralContext(route);
  const referralCode = String(ctx.referralCode || '').trim();
  if (!referralCode) return;

  const pageLabel = resolvePageLabel(route);
  if (!pageLabel) return;

  const gid = ctx.gameGroupId != null ? String(ctx.gameGroupId) : '';
  const dedupeKey = `page_visit:${referralCode}:${gid}:${pageLabel}`;
  try {
    if (sessionStorage.getItem(dedupeKey)) return;
    sessionStorage.setItem(dedupeKey, String(Date.now()));
  } catch {
    /* ignore */
  }

  reportPageVisitApi({
    referralCode,
    gameGroupId: ctx.gameGroupId || undefined,
    pageLabel,
  }).catch((err) => {
    console.warn('[pageVisit] report failed:', err);
  });
}
